//Update this function when changing cost of the delivery fee (regular rate) 
function getDeliveryFeeCost()
{
	return 3.99;
}

function setDeliveryFeeText() {
	var delivery_fee = getDeliveryFeeCost();
	var delivery_fee_spans = document.getElementsByClassName("delivery_fee_text");
	var num_spans = delivery_fee_spans.length;
	for(var i = 0; i < num_spans; i++) {
		var delivery_fee_span = delivery_fee_spans[i];
		delivery_fee_span.innerHTML = "$" + delivery_fee;
	}
}

$(window).on("load", setDeliveryFeeText);